import React from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled(Group)`
  min-width: 50%;
  height: 100%;

  ${mediaQueryUp.tablet} {
    min-width: unset;
    height: unset;
  }
`

function StatisticTrustIndicator() {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: '9q17CpnlW/',
    defaultMessage: '8 million members',
    description: 'Heading showing total member count in trust indicator',
  })
  const body = intl.formatMessage({
    id: '0FUd2TjK3B',
    defaultMessage: 'Trusted by',
    description: 'Label above member count in trust indicator',
  })

  return (
    <Container direction="vertical-reverse" horizontalAlign="center" verticalAlign="center" gap={4}>
      <Heading variant="heading3" align="center">{heading}</Heading>
      <BodyText colour="neutral-two" variant="medium" align="center">{body}</BodyText>
    </Container>
  )
}

export default StatisticTrustIndicator
